import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
@Component({
	selector: 'app-role-new',
	templateUrl: './role-new.component.html',
	styleUrls: [ './role-new.component.scss' ]
})
export class RoleNewComponent implements OnInit {
	pending: boolean;
	success: any;
	error: any;
	permissions: Array<any> = [];
	selectedRolePermissions: Array<any>;
	role;
	public checkOptions = [ { value: 'true' }, { value: 'false' } ];
	constructor(
		private location: Location,
		private modalService: SuiModalService // private formBuilder: FormBuilderService
	) {
		this.permissions = JSON.parse(window.localStorage.getItem('permissions'));
		this.selectedRolePermissions = [];
		let temp: Array<any> = [];
		this.selectedRolePermissions = Object.values(
			this.permissions.reduce((r, perm) => {
				const key = perm.groupName;
				r[key] = r[key] || { key: key, value: [] };
				r[key].value.push(perm);
				return r;
			}, {})
		);
	}
	deleteRole() {
		this.modalService
			.open(new ConfirmModal('Delete Role?', 'Are you sure you want to delete this role?', ModalSize.Tiny))
			.onApprove(() => {})
			.onDeny(() => {});
	}
	goBack() {
		this.location.back();
	}

	ngOnInit(): void {}
}
